import classNames from 'classnames';
import { ButtonUI, Prompt } from 'sonata-react-components';

import './promptModal.scss';

type Props = {
  cancelCallback: () => void;
  confirmCallback: () => void;
  texts: {
    buttons: {
      cancel: string;
      confirm: string;
    };
    description?: string;
    title: string;
  };
  variant?: 'warning' | 'default';
};

export default function PromptModal({ cancelCallback, confirmCallback, texts, variant = 'default' }: Props) {
  return (
    <Prompt className="promptModal__prompt" closePrompt={cancelCallback} width="770px">
      <Prompt.Icon icon="promptModal__promptIcon fas fa-exclamation-triangle" />
      <Prompt.Title className="promptModal__promptTitle" variant="warning">
        {texts.title}
      </Prompt.Title>
      <Prompt.Description
        className={classNames('promptModal__promptDescription', {
          'promptModal__promptDescription--warning': variant === 'warning'
        })}
        variant={variant}
      >
        {texts.description}
      </Prompt.Description>
      <Prompt.Buttons position="centered">
        <ButtonUI onClick={cancelCallback} shape="squareRounded" text={texts.buttons.cancel} type="secondary" />
        <ButtonUI onClick={confirmCallback} shape="squareRounded" text={texts.buttons.confirm} type="primary" />
      </Prompt.Buttons>
    </Prompt>
  );
}
